import * as React from "react";
/* empty css                             */
const ProductBlockGridDivider = ({ children }) => {
  return /* @__PURE__ */ React.createElement("div", { className: "product-block-grid-divider" }, children);
};
export {
  ProductBlockGridDivider
};
//# sourceMappingURL=ProductBlockGridDivider.js.map
